import styled from 'styled-components';
import { theme } from 'styled-tools';

import { Icon } from '@ui/icons';

import RouteStepIcon from './RouteStepIcon.tsx';

export type DestinationIconProps = {
  /** Venue POI icon ID for the final endpoint; the origin pin is shown without it. */
  name?: string;
};

const ORIGIN_PIN = 'wayfinding.start';

/** Clips square venue artwork to a circle. */
const Clip = styled.span`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: ${theme('iconSizes.md')}px;
  height: ${theme('iconSizes.md')}px;
  overflow: hidden;
  border-radius: ${theme('radii.full')};
`;

/** Same venue icon mechanism as the POI window; falls back to the origin pin. */
export default function DestinationIcon({ name }: DestinationIconProps) {
  if (!name) {
    return <RouteStepIcon name={ORIGIN_PIN} />;
  }
  return (
    <Clip aria-hidden="true" data-testid="DestinationIcon">
      <Icon
        name={name}
        cdn
        preserveArtworkColors
        width="100%"
        height="100%"
        fallback={<RouteStepIcon name={ORIGIN_PIN} />}
      />
    </Clip>
  );
}
